import { OverallResponseWrapper } from "@/components/overall-response/overall-response-wrapper";

const OverallMonitor = () => {
  return (
    <div className="h-full flex flex-col bg-background p-6 text-text-500">
      <div className="flex-1">
        <OverallResponseWrapper />
      </div>
    </div>
  );
};

export default OverallMonitor;
